import { memo } from 'react'

import Heading from './include/Heading'
import Image from './include/Image'
import { PageHeroProps } from './ts'

function PageHero({ kind }: PageHeroProps) {
  return (
    <main className="flex flex-col w-full space-y-12 box lg:space-x-12 lg:space-y-0 lg:justify-between lg:flex-row lg:items-center">
      <Heading kind={kind} />
      <Image kind={kind} />
    </main>
  )
}

export default memo(PageHero)
